import React from "react";
import UnifiedDashboard from "containers/AllInOneDashboard";

const UnifiedDashboardPage = () => <UnifiedDashboard />;

export default UnifiedDashboardPage;
